var _style, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFAzul(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.28 841.89",
    style: {
      enableBackground: "new 0 0 595.28 841.89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#233B63;stroke:#233B63;stroke-miterlimit:10;}\r\n\t.st1{fill:#233B63;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.5,590.87c10.49-29.71,29.25-56.72,53.99-79.14l20.74-18.8l-110.25,23.64 C73.35,544.72,28.13,499.85,12.99,455.2c-13.41-39.54-3.78-82.22,24.31-115.42c21.27-25.14,56.51-57.33,113.35-88.07 C268.89,187.75,487.8,13.96,487.8,13.96c14.43,15.51,21.75,33.72,25.18,50.78c6.05,30.08,0.64,61.02-14.33,88.64 c-15.86,29.26-46.48,73.58-97.93,104.58c-83.09,50.05-196.54,140.42-196.54,140.42c13.05,0.76,50.71-4.67,82.33-9.76 c24.7-3.98,49.21-8.77,73.57-14.08c72.87-15.88,128.52-19.26,128.52-19.26s62.32-1.39,91.08,38.93s-23.97,80.64-23.97,80.64 c-98.9,68.84-148.29,106.41-170.7,124.23c-12.14,9.65-23.35,26.35-28.65,39.9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 299.77,
    cy: 665.65,
    rx: 8.45,
    ry: 7.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.9,695.07c3.99-1.72,5.62-5.93,3.62-9.37c-1.99-3.44-6.87-4.85-10.86-3.13c-3.99,1.72-5.62,5.93-3.62,9.37 C310.14,695.34,314.91,696.79,318.9,695.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.95,696.75c3.99-1.72,5.51-5.88,3.57-9.23c-1.99-3.44-6.82-4.75-10.7-3.08c-3.99,1.72-5.51,5.88-3.57,9.23 C326.14,697.16,330.97,698.47,334.95,696.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.27,665.46c2.1,3.62,7.13,5.07,11.33,3.26s5.88-6.15,3.78-9.77c-2.1-3.62-7.13-5.07-11.33-3.26 C274.91,657.35,273.17,661.83,275.27,665.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M276.1,688.4c1.99,3.44,6.87,4.85,10.86,3.13c3.99-1.72,5.62-5.93,3.62-9.37c-1.99-3.44-6.87-4.85-10.86-3.13 C275.68,680.89,274.11,684.96,276.1,688.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 299.29,
    cy: 687.01,
    rx: 8.09,
    ry: 6.98
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 243.89,
    cy: 595.84,
    rx: 9.38,
    ry: 8.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 231.89,
    cy: 651.68,
    rx: 8.56,
    ry: 7.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.55,651.92c-2.1-3.62-7.18-5.16-11.49-3.31c-4.2,1.81-5.98,6.2-3.84,9.91c2.1,3.62,7.18,5.16,11.49,3.31 C256.97,659.88,258.65,655.54,256.55,651.92z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 252.21,
    cy: 628.56,
    rx: 8.92,
    ry: 7.69
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 304.61,
    cy: 644.56,
    rx: 8.92,
    ry: 7.69
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 234.69,
    cy: 623.22,
    rx: 8.92,
    ry: 7.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.76,665.23c4.2-1.81,5.88-6.15,3.78-9.77c-2.1-3.62-7.13-5.07-11.33-3.26s-5.88,6.15-3.78,9.77 C260.37,665.54,265.57,667.04,269.76,665.23z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 261.3,
    cy: 603.04,
    rx: 9.38,
    ry: 8.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 278.82,
    cy: 610.2,
    rx: 9.38,
    ry: 8.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 333.71,
    cy: 672.63,
    rx: 8.45,
    ry: 7.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M312.94,662.57c-4.2,1.81-5.88,6.15-3.78,9.77c2.1,3.62,7.13,5.07,11.33,3.26s5.88-6.15,3.78-9.77 C322.28,662.17,317.14,660.77,312.94,662.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M445.16,813.51c0.84,1.45,2.88,2.04,4.56,1.31c1.68-0.72,2.36-2.49,1.52-3.94c-0.84-1.45-2.88-2.04-4.56-1.31 C445.01,810.3,444.32,812.06,445.16,813.51z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 339.59,
    cy: 655.16,
    rx: 8.92,
    ry: 7.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M261.65,637.39c2.2,3.8,7.55,5.34,11.96,3.44c4.41-1.9,6.3-6.56,4.1-10.36c-2.2-3.8-7.55-5.34-11.96-3.44 C261.34,628.93,259.45,633.59,261.65,637.39z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 287.14,
    cy: 639.3,
    rx: 8.92,
    ry: 7.69
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 322.13,
    cy: 649.91,
    rx: 8.92,
    ry: 7.69
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 313.69,
    cy: 624.47,
    rx: 9.38,
    ry: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326.92,624.43c-4.62,1.99-6.51,6.88-4.2,10.86s7.97,5.61,12.59,3.63c4.62-1.99,6.51-6.88,4.2-10.86 C337.3,624.03,331.64,622.4,326.92,624.43z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 348.63,
    cy: 638.83,
    rx: 9.38,
    ry: 8.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 296.23,
    cy: 617.4,
    rx: 9.38,
    ry: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.85,811.44c-1.31-2.26-4.46-3.17-7.08-2.04c-2.62,1.13-3.67,3.85-2.36,6.11c1.31,2.26,4.46,3.17,7.08,2.04 C348.16,816.5,349.16,813.7,347.85,811.44z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 235.08,
    cy: 680.06,
    rx: 8.09,
    ry: 6.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M374.76,820.77c-0.26-0.45-0.58-0.77-0.89-1.09c1.31,0.45,2.78,0.5,4.04-0.04c2.41-1.04,3.36-3.48,2.15-5.57 c0,0-0.21-0.36-0.42-0.5c1.15,0.41,2.57,0.36,3.83-0.18c2.41-1.04,3.36-3.48,2.15-5.57c1.15,0.41,2.47,0.18,3.62-0.32 c2.41-1.04,3.36-3.48,2.15-5.57l-0.05-0.09c1.15,0.18,2.47,0.18,3.72-0.36c2.2-0.95,3.2-3.08,2.47-5.02 c1.15,0.41,2.57,0.36,3.72-0.13c2.41-1.04,3.36-3.48,2.15-5.57s-4.04-2.9-6.45-1.86c-2.2,0.95-3.1,3.03-2.36,4.98 c-1.26-0.36-2.57-0.36-3.83,0.18c-2.41,1.04-3.36,3.48-2.15,5.57c0.05,0.09,0.05,0.09,0.05,0.09c-1.1-0.32-2.52-0.27-3.67,0.22 c-2.41,1.04-3.36,3.48-2.15,5.57l0.05,0.09c-1.1-0.32-2.52-0.27-3.67,0.22c-2.41,1.04-3.36,3.48-2.15,5.57c0,0,0.21,0.36,0.42,0.5 c-1.15-0.41-2.57-0.36-3.83,0.18c-2.41,1.04-3.36,3.48-2.15,5.57c0.26,0.45,0.58,0.77,0.89,1.09c-1.31-0.45-2.78-0.5-4.14,0.09 c-2.41,1.04-3.41,3.62-2.21,5.7c1.21,2.08,4.2,2.94,6.61,1.9C374.91,825.34,375.96,822.85,374.76,820.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M428.53,821.92c1-1,1.37-2.4,0.63-3.67c1.31-0.9,1.89-2.4,1.31-3.85c0.21-0.09,0.47-0.09,0.68-0.18 c1.57-0.68,2.31-2.13,2.15-3.53c0.1-0.05,0.21-0.09,0.31-0.14c1.89-0.81,2.68-2.85,1.73-4.48c-0.94-1.63-3.3-2.31-5.19-1.5 c-1.57,0.68-2.36,2.04-2.1,3.39c-0.1,0.05-0.21,0.09-0.31,0.14c-1.78,0.77-2.57,2.58-1.89,4.21c-0.21,0.09-0.47,0.09-0.68,0.18 c-1.89,0.81-2.68,2.85-1.73,4.48c-1.42,0.95-1.99,2.67-1.16,4.12c-1.1,1.04-1.42,2.53-0.68,3.8c0.94,1.63,3.3,2.31,5.19,1.5 C428.63,825.5,429.47,823.55,428.53,821.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M403.45,822.32c-0.26-0.45-0.63-0.86-1.05-1.13c0.89,0.18,1.89,0.09,2.73-0.27c2.2-0.95,2.99-3.21,1.94-5.02 c0,0-0.05-0.09-0.1-0.18c0.84,0.09,1.68-0.04,2.41-0.36c2.2-0.95,2.99-3.21,1.94-5.02c-0.1-0.18-0.21-0.36-0.42-0.5 c0.84,0.09,1.68-0.04,2.41-0.36c2.1-0.9,2.94-3.08,2-4.93c0.84,0.09,1.57,0,2.31-0.32c2.1-0.9,2.99-3.21,1.94-5.02 c-1.05-1.81-3.72-2.58-5.82-1.68c-2.1,0.9-2.94,3.08-2.05,4.84c-0.84-0.09-1.68,0.04-2.41,0.36c-2.2,0.95-2.99,3.21-1.94,5.02 c0.1,0.18,0.21,0.36,0.42,0.5c-0.84-0.09-1.68,0.04-2.41,0.36c-2.2,0.95-2.99,3.21-1.94,5.02c0,0,0.05,0.09,0.1,0.18 c-0.84-0.09-1.57,0-2.41,0.36c-2.2,0.95-2.99,3.21-1.94,5.02c0.26,0.45,0.63,0.86,1.05,1.13c-0.89-0.18-1.89-0.09-2.83,0.32 c-2.2,0.95-3.1,3.26-2,5.16c1.1,1.9,3.78,2.67,5.98,1.72C403.66,826.53,404.55,824.22,403.45,822.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M359.26,762.52c2.99-1.4,4.15-4.61,2.52-7.19c-1.62-2.58-5.35-3.58-8.34-2.18c-1.94,0.95-3.15,2.71-3.26,4.57 c-1.84-2.04-5.14-2.76-7.82-1.5c-2.15,1.04-3.31,2.9-3.2,4.89c-1.89-1.68-4.93-2.17-7.4-1c-2.15,1.04-3.31,2.9-3.26,4.8 c-1.89-1.68-4.93-2.17-7.4-1c-2.15,1.04-3.31,2.9-3.31,4.93c-1.84-1.58-4.83-1.99-7.19-0.86c-2.36,1.13-3.46,3.3-3.15,5.43 c-1.89-1.22-4.56-1.54-6.71-0.5c-2.26,1.09-3.41,3.17-3.26,5.25c-1.84-1.36-4.62-1.63-6.92-0.64c-2.99,1.4-4.15,4.61-2.47,7.29 c1.62,2.58,5.35,3.58,8.45,2.13c2.26-1.09,3.41-3.17,3.26-5.25c1.84,1.36,4.62,1.63,6.92,0.64c2.36-1.13,3.57-3.35,3.26-5.47 c1.89,1.22,4.56,1.54,6.71,0.5c2.15-1.04,3.41-2.94,3.31-4.93c1.84,1.58,4.83,1.99,7.19,0.86c2.15-1.04,3.31-2.9,3.26-4.8 c1.89,1.68,4.93,2.17,7.4,1c2.15-1.04,3.31-2.9,3.26-4.8c1.89,1.68,4.93,2.17,7.4,1c2.05-0.99,3.15-2.71,3.26-4.57 C353.28,763.06,356.58,763.78,359.26,762.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.48,734.4c2.1-0.9,3.46-2.62,3.83-4.48c0.1,0.18,0.16,0.27,0.16,0.27c1.83,3.17,6.08,4.39,9.65,2.86 c2.1-0.9,3.46-2.62,3.83-4.48l0.21,0.36c1.73,2.99,6.03,4.3,9.6,2.76c3.46-1.49,4.99-5.2,3.2-8.28c-1.73-2.99-6.03-4.3-9.6-2.76 c-2.1,0.9-3.46,2.62-3.83,4.48c0,0-0.16-0.27-0.26-0.45c-1.78-3.08-6.03-4.3-9.6-2.76c-2.1,0.9-3.46,2.62-3.83,4.48 c-0.1-0.18-0.16-0.27-0.26-0.45c-1.78-3.08-6.03-4.3-9.6-2.76c-2.1,0.9-3.46,2.62-3.83,4.48c-0.1-0.18-0.16-0.27-0.26-0.45 c-1.78-3.08-6.03-4.3-9.6-2.76c-2.1,0.9-3.46,2.62-3.83,4.48c-0.1-0.18-0.16-0.27-0.26-0.45c-1.78-3.08-6.03-4.3-9.6-2.76 c-2.1,0.9-3.46,2.62-3.83,4.48c-0.1-0.18-0.16-0.27-0.16-0.27c-1.83-3.17-6.14-4.48-9.7-2.95c-2.1,0.9-3.46,2.62-3.83,4.48 c-0.1-0.18-0.16-0.27-0.26-0.45c-1.78-3.08-6.03-4.3-9.6-2.76c-3.57,1.54-4.99,5.2-3.2,8.28s6.03,4.3,9.6,2.76 c2.1-0.9,3.46-2.62,3.83-4.48c0.1,0.18,0.16,0.27,0.26,0.45c1.78,3.08,6.03,4.3,9.6,2.76c2.1-0.9,3.46-2.62,3.83-4.48 c0.1,0.18,0.16,0.27,0.26,0.45c1.78,3.08,6.03,4.3,9.6,2.76c2.1-0.9,3.46-2.62,3.83-4.48c0.1,0.18,0.16,0.27,0.26,0.45 c1.78,3.08,6.03,4.3,9.6,2.76c2.1-0.9,3.46-2.62,3.83-4.48c0.1,0.18,0.16,0.27,0.16,0.27C305.77,734.66,310.01,735.89,313.48,734.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.4,740.34c-1.62-2.81-5.61-4.03-8.97-2.58c-2.1,0.9-3.46,2.62-3.67,4.52c-0.05-0.09-0.1-0.18-0.1-0.18 c-1.68-2.9-5.66-4.12-9.02-2.67c-2.1,0.9-3.41,2.71-3.62,4.61c-1.83-2.49-5.56-3.49-8.6-2.18c-2.1,0.9-3.41,2.71-3.62,4.61 c-1.73-2.54-5.51-3.62-8.65-2.27c-2.1,0.9-3.41,2.71-3.62,4.61c-1.78-2.4-5.51-3.4-8.55-2.09c-2.2,0.95-3.46,2.85-3.62,4.84 c-1.94-1.99-5.24-2.72-8.08-1.5c-2.2,0.95-3.52,2.76-3.67,4.75c-1.99-2.08-5.3-2.81-8.24-1.54c-3.25,1.4-4.62,4.93-2.99,7.74 s5.72,3.98,8.97,2.58c2.2-0.95,3.52-2.76,3.67-4.75c1.99,2.08,5.3,2.81,8.24,1.54c2.2-0.95,3.57-2.89,3.62-4.84 c1.94,1.99,5.24,2.72,8.08,1.5c2.1-0.9,3.41-2.71,3.62-4.61c1.78,2.4,5.45,3.31,8.5,1.99c2.1-0.9,3.41-2.71,3.67-4.52 c1.73,2.54,5.51,3.62,8.65,2.27c2.1-0.9,3.41-2.71,3.62-4.61c1.83,2.49,5.56,3.49,8.6,2.18c2.1-0.9,3.41-2.71,3.67-4.52l0.16,0.27 c1.62,2.81,5.61,4.03,8.97,2.58C351.71,746.54,353.03,743.15,351.4,740.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.55,709.22c0.1,0.63,0.31,1.22,0.68,1.86c1.89,3.26,6.45,4.57,10.23,2.95c2.2-0.95,3.57-2.67,3.99-4.66 c0.1,0.63,0.31,1.22,0.68,1.86c1.89,3.26,6.45,4.57,10.23,2.95c2.2-0.95,3.57-2.67,3.99-4.66c0.1,0.63,0.31,1.22,0.68,1.86 c1.89,3.26,6.45,4.57,10.23,2.95c2.2-0.95,3.57-2.67,3.99-4.66c0.1,0.63,0.31,1.22,0.68,1.86c1.89,3.26,6.45,4.57,10.23,2.95 c3.78-1.63,5.3-5.56,3.41-8.82c-1.89-3.26-6.45-4.57-10.23-2.95c-2.2,0.95-3.57,2.67-3.99,4.66c-0.1-0.63-0.31-1.22-0.68-1.86 c-1.89-3.26-6.45-4.57-10.23-2.95c-2.2,0.95-3.57,2.67-3.99,4.66c-0.1-0.63-0.31-1.22-0.68-1.86c-1.89-3.26-6.45-4.57-10.23-2.95 c-2.2,0.95-3.57,2.67-3.99,4.66c-0.1-0.63-0.31-1.22-0.68-1.86c-1.89-3.26-6.45-4.57-10.23-2.95c-2.2,0.95-3.57,2.67-3.99,4.66 c-0.1-0.63-0.31-1.22-0.68-1.86c-1.89-3.26-6.45-4.57-10.23-2.95c-2.2,0.95-3.67,2.71-3.99,4.66c-0.1-0.63-0.37-1.31-0.68-1.86 c-1.89-3.26-6.45-4.57-10.23-2.95c-2.2,0.95-3.67,2.71-4.09,4.7c-0.1-0.63-0.37-1.31-0.68-1.86c-1.89-3.26-6.45-4.57-10.23-2.95 c-3.78,1.63-5.3,5.56-3.41,8.82c1.89,3.26,6.45,4.57,10.23,2.95c2.2-0.95,3.67-2.71,3.99-4.66c0.1,0.63,0.37,1.31,0.73,1.95 c1.89,3.26,6.45,4.57,10.23,2.95c2.2-0.95,3.67-2.71,3.99-4.66c0.1,0.63,0.37,1.31,0.68,1.86c1.89,3.26,6.45,4.57,10.23,2.95 C278.76,712.93,280.12,711.21,280.55,709.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.42,680.53c-1.99-3.44-6.87-4.85-10.86-3.13c-3.99,1.72-5.62,5.93-3.62,9.37 c1.99,3.44,6.87,4.85,10.86,3.13C274.73,688.08,276.36,683.88,274.42,680.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.42,678.71c-1.99-3.44-6.87-4.85-10.86-3.13c-3.99,1.72-5.62,5.93-3.62,9.37 c1.99,3.44,6.87,4.85,10.86,3.13C258.73,686.27,260.42,682.15,258.42,678.71z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 375.4,
    cy: 789.05,
    rx: 5.28,
    ry: 4.55
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 367.27,
    cy: 795.15,
    rx: 5.28,
    ry: 4.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.65,805.38c2.62-1.13,3.67-3.85,2.36-6.11c-1.31-2.26-4.46-3.17-7.08-2.04c-2.62,1.13-3.67,3.85-2.36,6.11 C355.83,805.51,359.03,806.51,361.65,805.38z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 383.38,
    cy: 782.89,
    rx: 5.28,
    ry: 4.55
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 351.16,
    cy: 807.41,
    rx: 5.28,
    ry: 4.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322.04,800.61c1.68,0.86,3.72,1,5.61,0.18c2.31-0.99,3.52-3.21,3.1-5.29c1.68,0.86,3.72,1,5.51,0.23 c2.31-0.99,3.41-3.17,3.1-5.29c1.68,0.86,3.72,1,5.51,0.23c2.31-0.99,3.41-3.17,3.1-5.29c1.68,0.86,3.72,1,5.61,0.18 c2.31-0.99,3.41-3.17,3.1-5.29c1.68,0.86,3.72,1,5.61,0.18c2.1-0.9,3.2-2.62,3.15-4.52c1.68,1.09,3.99,1.45,6.09,0.55 c2.83-1.22,3.99-4.21,2.57-6.65s-4.88-3.44-7.71-2.22c-1.99,0.86-3.2,2.62-3.15,4.52c-1.68-1.09-4.09-1.4-6.09-0.55 c-2.31,0.99-3.41,3.17-3.1,5.29c-1.68-0.86-3.72-1-5.61-0.18c-2.31,0.99-3.41,3.17-3.1,5.29c-1.68-0.86-3.72-1-5.51-0.23 c-2.31,0.99-3.41,3.17-3.1,5.29c-1.68-0.86-3.72-1-5.61-0.18c-2.31,0.99-3.52,3.21-3.1,5.29c-1.68-0.86-3.72-1-5.61-0.18 c-2.31,0.99-3.52,3.21-3.1,5.29c-1.68-0.86-3.72-1-5.61-0.18c-2.83,1.22-3.99,4.21-2.57,6.65s4.88,3.44,7.71,2.22 C321.26,804.91,322.46,802.69,322.04,800.61z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFAzul);
export default __webpack_public_path__ + "static/media/F_Azul.bb40c090c5968bd0049eecd367ee4f85.svg";
export { ForwardRef as ReactComponent };